export default{
    userInfo:state=>state.userInfo,
    menuRouterInfo:state=>state.menuRouterInfo,
    languageType:state=>state.languageType,

    
}